import React from 'react';
import { X, CheckCircle2, CalendarClock } from 'lucide-react';

// Panel mostrado al pulsar "Desmarcar" en la ficha del activo: el usuario
// elige entre resolver definitivamente la revisión o posponerla (nueva
// fecha + nota, sin cerrarla). Reutilizado por AssetDetailPage.
const ResolveOrPostponeChoiceModal = ({ open, onClose, onResolve, onPostpone }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(15, 23, 42, 0.55)', backdropFilter: 'blur(4px)' }}
      onClick={onClose}
      data-testid="resolve-or-postpone-modal-overlay"
    >
      <div
        className="rounded-xl shadow-2xl max-w-md w-full flex flex-col"
        style={{ background: 'var(--color-bg-elevated)' }}
        onClick={(e) => e.stopPropagation()}
        data-testid="resolve-or-postpone-modal"
      >
        <div className="flex items-start justify-between p-5 border-b" style={{ borderColor: 'var(--color-border)' }}>
          <div>
            <h3 className="font-semibold text-base" style={{ color: 'var(--color-text-primary)' }}>
              ¿Qué quieres hacer con esta revisión?
            </h3>
            <p className="text-xs mt-0.5" style={{ color: 'var(--color-text-muted)' }}>
              Puedes resolverla ahora o posponer su fecha para más adelante.
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-slate-700/20 rounded"
            aria-label="Cerrar"
            data-testid="resolve-or-postpone-close"
          >
            <X className="w-5 h-5" style={{ color: 'var(--color-text-muted)' }} />
          </button>
        </div>

        <div className="p-4 space-y-3">
          <button
            onClick={onResolve}
            className="w-full flex items-start gap-3 p-3 rounded-lg border text-left transition-colors hover:bg-emerald-500/10"
            style={{ borderColor: 'var(--color-border)' }}
            data-testid="resolve-or-postpone-choose-resolve"
          >
            <div className="w-9 h-9 shrink-0 rounded-full flex items-center justify-center bg-emerald-500 text-white">
              <CheckCircle2 className="w-4 h-4" />
            </div>
            <div>
              <p className="font-medium text-sm" style={{ color: 'var(--color-text-primary)' }}>Resolver</p>
              <p className="text-xs mt-0.5" style={{ color: 'var(--color-text-muted)' }}>
                Cierra la revisión definitivamente y notifica al solicitante.
              </p>
            </div>
          </button>

          <button
            onClick={onPostpone}
            className="w-full flex items-start gap-3 p-3 rounded-lg border text-left transition-colors hover:bg-amber-500/10"
            style={{ borderColor: 'var(--color-border)' }}
            data-testid="resolve-or-postpone-choose-postpone"
          >
            <div className="w-9 h-9 shrink-0 rounded-full flex items-center justify-center bg-amber-500 text-white">
              <CalendarClock className="w-4 h-4" />
            </div>
            <div>
              <p className="font-medium text-sm" style={{ color: 'var(--color-text-primary)' }}>Posponer</p>
              <p className="text-xs mt-0.5" style={{ color: 'var(--color-text-muted)' }}>
                Sigue abierta, pero con una nueva fecha de vencimiento y una nota explicativa.
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResolveOrPostponeChoiceModal;
